import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AlertItem {
    id: string;
    symbol: string;
    strike: number;
    type: 'CE' | 'PE';
    metric: 'oi' | 'volume' | 'ltp' | 'oiChg' | 'volOiDiff' | 'volOiChg';
    operator: 'gt' | 'lt';
    threshold: number;
    isActive: boolean;
    lastTriggered?: number;
}

interface AlertStore {
    alerts: AlertItem[];
    addAlert: (alert: Omit<AlertItem, 'id' | 'isActive'>) => void;
    removeAlert: (id: string) => void;
    toggleAlert: (id: string, isActive: boolean) => void;
    updateLastTriggered: (id: string, timestamp: number) => void;
}

export const useAlertStore = create<AlertStore>()(
    persist(
        (set) => ({
            alerts: [],
            addAlert: (alertData) =>
                set((state) => ({
                    alerts: [
                        ...state.alerts,
                        {
                            ...alertData,
                            id: Math.random().toString(36).substr(2, 9),
                            isActive: true,
                        },
                    ],
                })),
            removeAlert: (id) =>
                set((state) => ({
                    alerts: state.alerts.filter((a) => a.id !== id),
                })),
            toggleAlert: (id, isActive) =>
                set((state) => ({
                    alerts: state.alerts.map((a) =>
                        a.id === id ? { ...a, isActive } : a
                    ),
                })),
            updateLastTriggered: (id, timestamp) =>
                set((state) => ({
                    alerts: state.alerts.map((a) =>
                        a.id === id ? { ...a, lastTriggered: timestamp } : a
                    ),
                })),
        }),
        {
            name: 'options-oracle-alerts',
        }
    )
);
